import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
	standalone: false,
	selector: 'image-viewer',
	template: `
		<div class="overlay" (click)="close()"></div>
		<div class="file" (click)="close()">
			<ng-container *ngIf="item?.type?.indexOf('image') === -1">
				<visiba-svg a="File"></visiba-svg>
				<p class="fileName">{{ item.fileName }}</p>
			</ng-container>

			<ng-container *ngIf="item?.type?.indexOf('image') > -1">
				<img
					id="GaleryViewImage"
					[src]="viewUrl"
					alt=""
					(click)="stopClickThrough($event); (false)"
					(load)="setPlaceOnImageResolution()"
				/>
			</ng-container>

			<visiba-svg *ngIf="item?.type?.indexOf('image') > -1 && !imageElement" a="Loader"></visiba-svg>

			<div
				class="placeOnImage"
				[style.width.px]="imageElement?.clientWidth"
				[style.height.px]="imageElement?.clientHeight"
				(click)="cancelRemoval(); stopClickThrough($event); (false)"
			>
				<div class="ViewElements" (window:keydown)="onKey($event)">
					<div class="meta">
						<div *ngIf="item.uploader != null">
							{{ 'Component.FileViewer.Phrase.ImageUploadedBy' | translate: { name: item.uploader } : 1 }}
						</div>
						<div class="pointer" *ngIf="item.downloadUrl != null" (click)="downloadImage(item.downloadUrl)">
							<a>{{ 'Component.FileViewer.Button.Download' | translate }}</a>
						</div>
					</div>
					<div class="closeHolder">
						<span class="index">{{
							'Component.FileViewer.Phrase.FileIndex' | translate: { current: activeFileInd + 1, total: images?.length } : 1
						}}</span>
						<visiba-svg a="XCircle" (click)="close()"></visiba-svg>
					</div>

					<div (click)="select(-1); stopClickThrough($event); (false)" *ngIf="activeFileInd > 0" class="nav prev">
						<visiba-svg a="ArrowLeft"></visiba-svg>
					</div>
					<div (click)="select(1); stopClickThrough($event); (false)" *ngIf="images?.length > activeFileInd + 1" class="nav next">
						<visiba-svg a="ArrowRight"></visiba-svg>
					</div>

					<div class="removeImage" *ngIf="this.onRemove.observers?.length > 0">
						<div
							class="trashIcon"
							[style.transform]="isRemoveStepOneComplete ? 'scale(1.2)' : 'scale(1)'"
							(click)="removeImage(); stopClickThrough($event); (false)"
						>
							<visiba-svg a="Trashcan"></visiba-svg>
						</div>
						<p *ngIf="!isRemoveStepOneComplete">{{ 'Common.Button.Delete' | translate }}</p>
						<p *ngIf="isRemoveStepOneComplete">{{ 'Component.FileViewer.Phrase.DeleteConfirm' | translate }}</p>
					</div>
				</div>
			</div>

			<img class="preload" *ngIf="images?.length > activeFileInd + 1" [src]="images[activeFileInd + 1].viewUrl" alt="" />
			<img class="preload" *ngIf="activeFileInd > 0" [src]="images[activeFileInd - 1].viewUrl" alt="" />
		</div>
	`,
})
export class ImageViewerComponent {
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	@Input('images') images: Array<any>;
	@Input('startIndex') activeFileInd: number = 0;
	@Output() onClose = new EventEmitter();
	@Output() onRemove = new EventEmitter<number>();
	imageElement: HTMLElement;

	isRemoveStepOneComplete: boolean = false;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	item: any;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	viewUrl: any;

	constructor(
		private _changeDetectorRef: ChangeDetectorRef,
		private http: HttpClient,
	) {}
	ngOnInit() {
		this.selectPicture();
	}

	@HostListener('window:resize', ['$event.target'])
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	onWindowResize(event: any) {
		this._changeDetectorRef.detectChanges();
	}

	setPlaceOnImageResolution() {
		this.imageElement = document.getElementById('GaleryViewImage');
	}

	selectPicture() {
		if (this.activeFileInd >= 0 && this.activeFileInd < this.images.length) {
			this.item = this.images[this.activeFileInd];
			this.viewUrl = this.item.viewUrl;
		}
	}

	select(dir: number) {
		this.activeFileInd = Math.max(0, Math.min(this.images.length - 1, this.activeFileInd + dir));
		this.isRemoveStepOneComplete = false;
		this.selectPicture();
	}
	close() {
		this.onClose.emit();
	}
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	stopClickThrough(e: any) {
		e.stopPropagation();
	}
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	onKey(e: any) {
		if (e.keyCode === 37) {
			this.select(-1);
		} else if (e.keyCode === 39) {
			this.select(1);
		}
	}
	removeImage() {
		if (this.isRemoveStepOneComplete === false) {
			this.isRemoveStepOneComplete = true;
			return;
		}
		this.onRemove.emit(this.activeFileInd);
		this.isRemoveStepOneComplete = false;

		if (this.activeFileInd !== 0) {
			this.activeFileInd -= 1;
		}

		if (this.images.length === 0) {
			this.onClose.emit();
		}
		this.selectPicture();
	}
	cancelRemoval() {
		this.isRemoveStepOneComplete = false;
	}

	downloadImage(imageUrl: string) {
		this.http
			.get(imageUrl, {
				withCredentials: true,
				observe: 'response',
				responseType: 'blob',
			})
			.subscribe(
				(response) => {
					const filenameRegex = /filename="(.*?)"/gi;
					const uuidRegex = /http.+\/(.*)/gi;

					let filename = '';

					const contentDisposition = response.headers.get('Content-Disposition');

					if (contentDisposition) {
						const filenameMatch = filenameRegex.exec(contentDisposition);

						// Using [1] to get the group value
						if (filenameMatch !== null && filenameMatch[1]) {
							filename = filenameMatch[1];
						}
					}

					// If the contentDisposition getting fails, default to uuid and in worst cast just
					// call it "picture"
					if (filename === '') {
						const uuidMatch = uuidRegex.exec(imageUrl);

						// Using [1] to get the group value
						if (uuidMatch !== null && uuidMatch[1]) {
							filename = uuidMatch[1];
						} else {
							filename = 'picture';
						}
					}

					const blobUrl = URL.createObjectURL(response.body);
					const link = document.createElement('a');
					link.href = blobUrl;
					link.download = filename;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				},
				// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
				(error) => {},
			);
	}
}

export module ImageViewerComponent {
	export class image {
		constructor(
			public viewUrl: string = null,
			public uploader: string = null,
			public downloadUrl: string = null,
			public fileName: string = null,
			public type: string = null,
		) {}
	}
}
